export enum BalanceOptions {
  withBalance = 'withBalance',
  withoutBalance = 'withoutBalance',
  percentage = 'percentage',
}

export enum BalanceOptionsForVolumeValues {
  withBalance = 'WithBalance',
  withoutBalance = 'WithoutBalance',
  percentage = 'InPercentage',
}

export enum BalanceOptionsAmountType {
  withBalance = 'amountWithBalance',
  withoutBalance = 'amountWithoutBalance',
  percentage = 'amountInPercentage',
}

export enum ActiveTabs {
  ingredients = 'ingredients',
  equipments = 'equipment',
}

export enum ProductTypes {
  ingredient = 'ingredient',
  equipment = 'equipment',
}

export interface IngredientProduct {
  sku: string;
  _name: string;
  images: { url: string }[];
  _slug: string;
  _categories: any[];
}

export interface IngredientsStore {
  ingredients: Ingredient[];
  equipmentProducts: Equipment[];
  balanceOption: BalanceOption;
  volumeOption: VolumeOption;
  findIngredient: (sku: string) => any;
  findEquipment: (sku: string) => any;
  setIngredients: (products: Ingredient[]) => void;
  setEquipmentProducts: (equipmentProducts: Equipment[]) => void;
  setBalanceOption: (balanceOption: BalanceOption) => void;
  setVolumeOption: (volumeOption: VolumeOption) => void;
  reset: () => void;
  findQuantity: (quantities: any[], phase?: string) => string | any[] | undefined;
}

export interface IngredientQuantities {
  fields: {
    QuantityToCreate: {
      fields: {
        quantityToCreate;
      };
      sys: { id: string };
    };
  };
}

export interface Ingredient {
  fields: {
    ingredientSku: string;
    quantities: IngredientQuantities[];
  };
  metadata: {};
  sys: {};
}

export interface Equipment {
  fields: {
    equipmentSku: string;
    balance: string;
  };
  metadata: {};
  sys: {};
}

export interface BasicOption<T> {
  code: string;
  key: T;
}

export interface BalanceOption extends BasicOption<BalanceOptions> {}

export interface VolumeOption extends BasicOption<string> {}

export interface KeyBenefit {
  fields: {
    image: {};
    title: string;
  };
  metadata: {};
  sys: {};
}
